<template>
  <div>
    <div>
      <editLogForm
        v-if="this.toggleEditLogForm == true"
        :log="this.CurrentlyEditingLog"
        :propertyid="this.propertyid"
        v-on:updated-log="updateLogLocally($event)"
        v-on:close-EditLogForm="toggleEditLogFormMethod()"
      />
      <DeleteLogForm
        v-if="this.toggleDeleteLogForm == true"
        :log="this.CurrentlyDeletingLog"
        v-on:delete-log-locally="deleteLogLocally($event)"
        v-on:close-DeleteLogForm="toggleDeleteLogFormMethod()"
      />
    </div>

    <div>
      <div v-if="this.loading == false">
        <div style="width: 84%; padding: 20px 8%">

            <p  v-if="this.loglist.length == 0" class="no-notes">
              No comments.
            </p>


          <div class="log-card" v-for="log in this.loglist" :key="log.logid">
            <el-divider></el-divider>
            <div class="log" style=" display: flex;
              flex-direction: row;">
              <el-avatar
                :size="45"
                :src="log.userspicurl"
                style="min-width:45px; margin-right:10px;"
              ></el-avatar>
              <div style="width:100%; overflow: hidden;">
                <div
                  style="width:100%; display: flex;
                  justify-content: space-between;
                   color:#c0c0c0;"
                >
                  <h4 style="width:90%; margin-top:0px">
                    <span style="color:black;">{{ log.firstname }} {{ log.lastname }}</span>
                    -
                    {{
                    log.logdate
                    | moment("timezone", $timeZone, "MMM DD YYYY hh:mm A")
                    }}
                  </h4>
                  <div style="left:0;">
                    <el-dropdown
                      v-if="log.canedit == true || log.candelete == true || log.userid == user.userid"
                    >
                      <el-button type="text">
                        <i class="el-icon-s-operation"></i>
                      </el-button>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item v-if="log.userid == user.userid || log.canedit == true">
                          <el-button 
                          style="color:unset"
                          @click.native="toggleEditLogFormMethod(log)"
                           type="text"
                           >
                            <i class="fa fa-edit mt-2"></i>Edit comment
                          </el-button>
                        </el-dropdown-item>
                        <el-dropdown-item
                          v-if="
                          log.userid == user.userid || log.candelete == true
                        "
                        >
                          <el-button
                          type="text"
                          style="color:unset"
                            class="btn btn-icon-only text-light"
                            @click.native="toggleDeleteLogFormMethod(log)"
                          >
                            <i class="fa fa-trash mt-2"></i> Delete comment
                          </el-button>
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                </div>
                <div style="background-color: #EBEFF2; border-radius:3px; padding:1%; overflow-wrap: break-word; font-size: 16px;">
                  {{ log.note }}
                  <br />
                  <br />
                  <div class="logimageholder">
                    <el-image
                      v-for="img in log.imageurl"
                      :key="img"
                      :preview-src-list="log.imageurl"
                      :src="img"
                      fit="contain"
                      style="width:200px; height:200px; background-position: center center;
                        background-repeat: no-repeat; padding:1%;"
                    >
                      <div slot="placeholder" class="image-slot">
                        <i class="el-icon-picture-outline"></i>
                      </div>
                    </el-image>
                  </div>
                  <div v-for="file in log.files" :key="file.fileid">
                    <el-row>
                      <el-button
                        type="primary"
                        size="mini"
                        @click.native="downloadFile(file.fileurl)"
                        icon="fas fa-file-download"
                        circle
                      ></el-button>
                      {{ file.filename }}
                    </el-row>
                  </div>
                </div>
              </div>
            </div>

          </div>
        <div style="">

        <el-button 
        class="unread-button"
            style="" 
            v-if="this.unreadMessagesLocalVar > 0"
            type="danger" 
            @click="unreadMessagesScroller" >
            {{unreadMessages}} unread messages 
            <i style="margin-left: 3px;" class="fas fa-arrow-down"></i>
        </el-button>

    </div>
          <div id="bottom"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import EditLogForm from "@/components/logs/EditLogForm.vue";
import DeleteLogForm from "@/components/logs/DeleteLogForm.vue";
import fab from "vue-fab";

export default {
  props: {
    loglist: Array,
    logheaders: Object,
    issueid: String,
    loading: Boolean,
    onSingleIssuePage: Boolean,
    propertyid: String,
    unreadMessages: Number
  },
  components: {
    EditLogForm,
    DeleteLogForm,
    fab
  },
  data() {
    return {
      toggleCreateLogForm: true,
      toggleEditLogForm: false,
      toggleDeleteLogForm: false,
      CurrentlyEditingLog: {},
      CurrentlyDeletingLog: {},
      cancreatenote: this.logheaders.cancreatenote,
      unreadMessagesLocalVar: this.unreadMessages
    };
  },
  created() {},
  mounted() {
    //check if all new messages show on the screen, so it shouldn't display scroll button

 this.$parent.$on("local-log-return-data",  () => alert("LLLL"))

    
  },
  updated() {
      //       this.unreadMessagesLocalVar = this.unreadMessages;

     this.$nextTick(() => {

              var elmnt = document.getElementById("bottom");

        var rect = elmnt.getBoundingClientRect();
        var elemTop = rect.top;
        var elemBottom = rect.bottom;

        // Only completely visible elements return true:
        var isVisible = (elemTop >= 0) && (elemBottom <= window.innerHeight);

        if(isVisible == true){
        this.$emit("messages-read");
          this.unreadMessagesLocalVar = 0;
        }
        });

    this.cancreatenote = this.logheaders.cancreatenote;
  },

  methods: {
    downloadFile(fileurl) {
      location.href = fileurl;
    },
    closeFormsFromBackButton() {
      console.log("close forms from back button is closing");
      this.toggleCreateLogForm = false;
      this.toggleEditLogForm = false;
      this.toggleDeleteLogForm = false;
    },
    toggleCreateLogFormMethod() {
      this.toggleCreateLogForm = !this.toggleCreateLogForm;
    },

    toggleEditLogFormMethod(log) {
      this.toggleEditLogForm = !this.toggleEditLogForm;
      this.CurrentlyEditingLog = log;
     // this.changeBackButton();
    },
    toggleDeleteLogFormMethod(log) {
      this.toggleDeleteLogForm = !this.toggleDeleteLogForm;
      this.CurrentlyDeletingLog = log;
    //  this.changeBackButton();
    },

    // addLogLocally($event) {
    //   this.loglist.push($event);
    // },
    updateLogLocally($event) {
      this.$set(this.loglist, this.loglist.indexOf($event[0]), $event[1]);
    },
    deleteLogLocally($event) {
      this.$delete(this.loglist, this.loglist.indexOf($event));
    },
    unreadMessagesScroller(){
    this.scrollToBottom();
    this.unreadMessagesLocalVar = 0;

    },
    scrollToBottom() {
      var elmnt = document.getElementById("bottom");
      elmnt.scrollIntoView();
    }
  },
  computed: {
    ...mapState({
      user: state => state.user.user
    })
  }
};
</script>

<style scoped>
body {
  margin: 0px;
}

.note {
  width: 70%;
  margin: 30px auto;
  background-color: #e0f2f1;
  color: #004d40;
  border-radius: 25px;
  position: relative;
}

p.date {
  display: inline-block;
  font-family: Roboto, "Helvetica Neue", sans-serif;
  font-size: 1rem;
  margin: 10px;
}

p#owner {
  display: block;
  margin: 18px 7px;
  font-size: 1rem;
}

p#note-content {
  display: block;
  padding: 5px 15px;
  line-height: 30px;
  word-spacing: 0.1rem;
}

.no-notes{
    color: rgb(64, 64, 64);
    text-align: center;
}

.unread-button{
      z-index: 5;
      position: absolute;
      bottom: 90px;
      left: calc(50% + 80px); 
      padding: 6px 20px;
      border: 1px solid white; 
      border-radius: 15px;
}
@media (min-width: 320px) and (max-width: 979px) {

p.date {
  font-size: 0.8rem;
  margin-left: 10px;
}

p#owner {
  margin: 10px 5px;
}

p#note-content {
  font: 15px/22px Roboto, "Helvetica Neue", sans-serif;
}
.unread-button{
  left: 50%;
  transform: translateX(-50%);
}
}
</style>
